// テキスト・付箋配置時の文字寄せ（左/中央/右）の選好を localStorage に保存する。
// 文字サイズの選好（text-size-preference）と同じ方針で、挿入前の設定値を次回も再現する。

import type { TextAlign } from "@refinement-canvas/domain";

const KEY = "refinement-canvas:text:align";

/** 保存値が無いとき・壊れているときに使う既定の文字寄せ。要望どおり既定は左寄せ。 */
export const DEFAULT_TEXT_ALIGN: TextAlign = "left";

const VALID_ALIGNS: readonly TextAlign[] = ["left", "center", "right"];

/** 任意の文字列が有効な TextAlign かどうかを判定する。 */
export function isTextAlign(value: unknown): value is TextAlign {
  return typeof value === "string" && VALID_ALIGNS.includes(value as TextAlign);
}

export function loadTextAlign(): TextAlign {
  try {
    const raw = window.localStorage.getItem(KEY);
    if (raw === null) return DEFAULT_TEXT_ALIGN;
    return isTextAlign(raw) ? raw : DEFAULT_TEXT_ALIGN;
  } catch {
    return DEFAULT_TEXT_ALIGN;
  }
}

export function saveTextAlign(align: TextAlign): void {
  try {
    window.localStorage.setItem(KEY, align);
  } catch {
    // ignore（プライベートブラウジング等）
  }
}
